var irreducible = require('./irreducible');
var isFunction = require('./isFunction');

module.exports = irreducible('Function', isFunction);



//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/Function.js
// module id = 179
// module chunks = 0